import { FadeInDownAnimation, FadeInDownDiv } from "components/Animations/FadeInDown";
import { Bagde, OrderCard } from "components/Card";
import { DATE_FORMAT_PRINT } from "config/constants";
import { JobTypeColor } from "config/status";
import useText from "constants/text";
import { NewJobContext } from "domains/Job/context";
import { RecapView } from "domains/Parcel/components/Details/NewOrderDetails";
import { useJobDetails, ViewArticles } from "domains/Task/components/Job/JobRightSideUtils";
import { Job, JobType, Order } from "generated/graphql";
import { ClocksIcon, DateIcon, PlaceIcon } from "icons";
import moment from "moment";
import React from "react";
import "styled-components/macro";
import { useJobDetailsStyles } from "../styles";

export interface OrderViewProps {
  styles?: any;
  order?: Order;
  warning?: boolean;
  background?: string;
  leftBarreColor?: string;
  onClickOrderView?: (order: Order) => void;
}

export const OrderView = ({
  styles,
  order,
  warning = false,
  background = "#fff",
  leftBarreColor = "#399ebf",
  onClickOrderView,
}: OrderViewProps) => {
  const classes = useJobDetailsStyles();

  return (
    <div className={classes.root}>
      <div
        css={`
          background-color: ${warning ? "#FFE7E7" : background};
        `}
        className={classes.warningDiv}
      >
        <div
          style={{
            marginBottom: "auto",
            marginTop: "auto",
          }}
        >
          <Bagde value="" variante="contained" height={10} width={10} color={warning ? "#F47F7F" : leftBarreColor} />
        </div>
      </div>
      <div
        css={`
          position: relative;
          right: -30px;
        `}
      >
        <OrderCard
          noBox
          elevation={0}
          height={90}
          width={235}
          warning={warning}
          style={{
            background: background ?? "#fff",
            height: 90,
            width: 290,
          }}
          leftBarreColor={leftBarreColor}
        >
          <div className={styles.car}>
            <div
              css={`
                color: ${warning ? "#F47F7F" : leftBarreColor};
              `}
              className={classes.orderStyle}
            >
              Order
            </div>
            <div className={classes.receiverStyle}>
              <div style={{ padding: "5px 5px 5px 0px" }}>
                {order?.order_receiver?.receiver_lastname} {order?.order_receiver?.receiver_firstname}
              </div>
              <ViewArticles color={leftBarreColor} onClick={() => onClickOrderView(order)}>
                {" "}
                {order?.order_parcels?.length || "?"} articles
              </ViewArticles>
            </div>
            <div className={classes.address}>{order?.order_receiver?.receiver_address?.address}</div>
          </div>
        </OrderCard>
      </div>
    </div>
  );
};

interface JobDescriptionProps {
  historyJob?: Job;
  showReloadButton?: boolean;
}
export function JobDescription({
  historyJob,
  showReloadButton = false,
}: JobDescriptionProps) {
  const styles = useJobDetails();
  const { job, orders } = React.useContext(NewJobContext);
  const [jobView, setJobView] = React.useState<Job>(null);
  const { text } = useText();

  React.useEffect(() => {
    if (historyJob) {
      setJobView(historyJob);
    } else {
      setJobView(job);
    }
  }, [job, historyJob]);

  return (
    <div className={showReloadButton ? styles.root1 : styles.root}>
      <div className={styles.content} >
        <FadeInDownDiv
          className={styles.pickContent}
          style={{
            visibility: jobView === null ? "hidden" : "visible",
          }}
          css={`
            animation: 2.5s ${jobView !== null ? FadeInDownAnimation : "none"};
          `}
        >
          <div
            css={`
              margin-top: auto;
              margin-bottom: auto;
            `}
          />
          <div className={styles.pickupInfo}>
            <div className={styles.date} >
              <div color={JobTypeColor[jobView?.job_type]}>
                {jobView?.job_type === JobType.FromStock && text.all.from_stock_label}              
                {jobView?.job_type === JobType.Dropoff && text.all.drop_off_label}
                {jobView?.job_type === JobType.Pickup && text.all.pickup_label}
              
                <hr className={styles.hr} />
              </div>
            </div>
            <div className={styles.place}>
              <PlaceIcon />
              <p>{jobView?.job_address?.address}</p>
            </div>
            <div className={styles.date_header}>
              <div>
                <DateIcon />
                <span>{moment(jobView?.job_date).format(DATE_FORMAT_PRINT)}</span>
              </div>

              <div>
                <ClocksIcon />
                <span>{jobView?.job_time}</span>
              </div>
            </div>
            {orders?.length > 0 && <div className={styles.date}>{text.all.client} <hr className={styles.hr} /></div>}
          </div>
        </FadeInDownDiv>
      </div>
      <div className={showReloadButton ? styles.orderDisplay1 : styles.notShow}>
        {orders &&
          orders.map((order: Order, index: number) => (
            // eslint-disable-next-line react/no-array-index-key
            <RecapView order={order} />
          ))}
      </div>
    </div>
  );
}

